<template>
  <div class="account-business-page w-100 p-3">
    <div class="d-flex account-business-tabs">
      <div v-for="menu in listMenu" :key="menu.val">
        <el-tag
          @click="handleSelectMenu(menu.val)"
          v-bind:style="menu.val === activeMenu ? activeMenuStyle : normalMenuStyle"
          effect="dark"
          style="height:40px"
          class="pointer text-center pt-1 px-3 mx-2 my-2 fw-bold font-size-16">
          {{ menu.label }}
        </el-tag>
      </div>
    </div>
    <div class="account-business-divider" />

    <div v-if="activeMenu === 'account'" class="account-business-card">
      <div class="d-flex justify-content-between align-items-center account-business-header">
        <div>
          <div class="account-business-title fw-bold">Danh sách tài khoản hệ thống</div>
          <div class="account-business-description">
            Tìm kiếm và cấu hình duy trì đăng nhập cho tài khoản.
          </div>
        </div>
        <el-input
          v-model="searchKey"
          clearable
          size="small"
          prefix-icon="el-icon-search"
          placeholder="Tìm theo tài khoản, số điện thoại hoặc companyCode"
          class="account-business-search"
          @input="searchAccount" />
      </div>

      <el-table
        :data="accounts"
        border
        size="small"
        class="account-business-table"
        empty-text="Nhập từ khóa để tìm kiếm">
        <el-table-column prop="id" label="ID" width="90" />
        <el-table-column prop="swUsername" label="Tài khoản" min-width="220" />
        <el-table-column prop="phone" label="Số điện thoại" min-width="160" />
        <el-table-column prop="companyCode" label="CompanyCode" min-width="170" />
        <el-table-column label="Duy trì đăng nhập" width="170" align="center">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.checkIpWhiteList" @change="save(scope.row)" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <BackOffice v-else />
  </div>
</template>

<script>
import BackOffice from "@/pages/BackOffice";

export default {
  name: "AccountManagement",
  components: {
    BackOffice
  },
  props: {
    initialTab: {
      type: String,
      default: "account"
    }
  },
  data() {
    return {
      activeMenu: this.initialTab || "account",
      searchKey: "",
      accounts: [],
      listMenu: [
        { label: "Tài khoản hệ thống", val: "account" },
        { label: "Back Office", val: "backOffice" }
      ]
    };
  },
  computed: {
    activeMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#0A58C0",
        "background-color": this.setTransparencyHex("#0A58C0", 0.08),
        margin: "1px 4px 3px 1px"
      };
    },
    normalMenuStyle() {
      return {
        "border-radius": "4px",
        border: "0px solid",
        color: "#696B72",
        "background-color": "transparent",
        margin: "1px 4px 3px 1px"
      };
    }
  },
  watch: {
    initialTab(tab) {
      this.activeMenu = tab || "account";
    }
  },
  methods: {
    handleSelectMenu(menu) {
      this.activeMenu = menu;
    },
    save(selectAccount) {
      this.$http.post("/api/user/saveIpWhiteList", selectAccount).then(() => {
        this.searchAccount();
        this.alert("success", "Cập nhật thành công.");
      });
    },
    searchAccount() {
      const searchKey = (this.searchKey || "").trim();
      if (!searchKey) {
        this.accounts = [];
        return;
      }
      this.$http.get("/api/user/search", {
        params: {
          searchKey: searchKey
        }
      }).then((res) => {
        this.accounts = res.data || [];
      });
    }
  }
};
</script>

<style scoped>
.account-business-page {
  background: #fafafa;
  min-height: 100vh;
}

.account-business-tabs {
  overflow-x: auto;
}

.account-business-divider {
  border-top: solid #eee 2px;
  margin: 0 8px 12px;
}

.account-business-card {
  background: #ffffff;
  border: 1px solid #dcdfe9;
  border-radius: 8px;
  padding: 12px;
}

.account-business-header {
  gap: 12px;
  margin-bottom: 12px;
}

.account-business-title {
  color: #202125;
  font-size: 16px;
}

.account-business-description {
  color: #696b72;
  font-size: 14px;
  margin-top: 4px;
}

.account-business-search {
  max-width: 380px;
}

::v-deep .account-business-table {
  font-size: 14px;
}

::v-deep .account-business-table th {
  color: #696b72;
  font-size: 14px;
  font-weight: 700;
}

@media (max-width: 768px) {
  .account-business-header {
    align-items: stretch !important;
    flex-direction: column;
  }

  .account-business-search {
    max-width: none;
  }
}
</style>
